import React from 'react'
import Icons from '~/Common-Objects/UI/Icons'

export default function ChipUpsell({ children, className, onClick, icon = 'chevronsUp', hideIcon = false, ...rest }) {
    let classes = 'chip-upsell'
    if (onClick) {
        classes += ' clickable'
    }
    if (className) {
        classes += ` ${className}`
    }
    return (
        <div className={classes} onClick={onClick} {...rest}>
            {!hideIcon && (
                <Icons className='icon' icon={icon} color='var(--pink-500)' style={{ width: '14px', height: '14px' }} />
            )}
            <div className='text'>{children}</div>
        </div>
    )
}
